import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldAlert, Download } from "lucide-react";
import { useToast } from "../../components/Toast";

export default function BlockPage() {
  const push = useToast();
  const navigate = useNavigate();
  const [downloading, setDownloading] = useState(false);

  const click = () => {
    setDownloading(true);
    setTimeout(() => {
      setDownloading(false);
      push({ kind: "success", text: "APK маркета скачан, ставится…" });
      navigate("/client");
    }, 1500);
  };

  return (
    <div className="flex h-full flex-col items-center justify-center px-6 text-center">
      <span
        className="grid h-16 w-16 place-items-center rounded-2xl bg-[var(--color-danger-bg)] text-[var(--color-danger)]"
        aria-hidden
      >
        <ShieldAlert size={28} />
      </span>
      <h1 className="mt-4 text-[18px] font-semibold tracking-[-0.005em] text-[var(--color-fg)]">
        Требуется обновление
      </h1>
      <p className="mt-2 max-w-[280px] text-[13px] leading-relaxed text-[var(--color-fg-muted)]">
        Версия маркета несовместима с этим Локальным сервером. Скачайте и установите новую версию для продолжения работы.
      </p>

      <div className="mt-6 w-full max-w-[320px] space-y-1 rounded-xl border border-[var(--color-border)] bg-[var(--color-surface-2)] p-3 text-left">
        <Row label="ваш клиент"  value="v 1.2.4 · proto 2" color="var(--color-danger)" />
        <Row label="требуется"   value="v 1.4.0 · proto 3" color="var(--color-success)" />
        <Row label="источник"    value="msk-01.market.corp" />
      </div>

      <button
        onClick={click}
        disabled={downloading}
        className="mt-6 inline-flex w-full max-w-[320px] items-center justify-center gap-2 rounded-xl bg-[var(--color-brand)] py-3.5 text-[14px] font-semibold text-white transition-all hover:bg-[var(--color-navy-700)] disabled:opacity-70"
      >
        <Download size={16} className={downloading ? "spin" : ""} />
        {downloading ? "Скачивание…" : "Скачать APK маркета · 6.2 MB"}
      </button>
      <p className="mt-3 max-w-[280px] text-[11.5px] text-[var(--color-fg-muted)]">
        После установки маркет переоткроется. Все данные сохранятся.
      </p>
    </div>
  );
}

function Row({ label, value, color }: { label: string; value: string; color?: string }) {
  return (
    <div className="flex items-center justify-between gap-3 py-1.5 text-[12px]">
      <span className="font-mono text-[var(--color-fg-muted)]">{label}</span>
      <span className="font-mono" style={{ color: color ?? "var(--color-fg)" }}>{value}</span>
    </div>
  );
}
